export enum PaymentChannelIntegrationType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}
